<div class="bg-img">
  <div class="gradient">
    <div class="container mx-auto text-center lg:text-left">
      <h1>{{ title }}</h1>
    </div>
  </div>
</div> 